var FileService =  require("../services/file.service.js").default;

module.exports = function (metadata) {
  if(FileService.hasVideoAnalytics(metadata)){
    return FileService.formatDuration(metadata.video_duration)
  }
  return FileService.formatSize(metadata.content_length);
};
